export default "<div [@collapseState]=\"isCollapsed ? 'active' : 'inactive'\">\n    <ng-content></ng-content>\n</div>\n";